<app-tabs tabsId="settings" (tabChanged)="updateActiveTabId($event)" [tabs]="tabs"></app-tabs>
<div style="min-height: 300px;">
    <div *ngIf="activeTabId =='paymentmethods'" app-paymentmethods></div>
</div>